// import PrimeApp from './PrimeApp';
import { Component, Log } from '@WidgetWorks';

export default class UploadButton extends Component {
    constructor(appConfig, apiFilter = {}) {
        super(appConfig);
        this.interacted = false;
        this.continueButtonHandler = this.continueButton.bind(this);

        // API Filter Configurations
        this.apiFilter = apiFilter;

        // This app requires a displayer.
        // so from your app, references it. By default, it's the parent.
        // but you can over-ride this for your own visualiser app.
        this.displayApp = this.parent;
        this.parentName = null;

        // Has a goback setting
        this.goBack = true;
    }

    overrideHook() {}

    preRenderHook() {}

    beforeMountHook() {
        this.root = this.element.shadowRoot.querySelector('section');
    }

    postRenderHook() {}

    validateDisplayAppImplementation() {
        const requiredFunctions = ['toggleLoading', 'errorPage'];
        for (const funcName of requiredFunctions) {
            if (typeof this.displayApp[funcName] !== 'function') {
                throw new Error(`Display app implementation is not valid. The function "${funcName}" is missing.`);
            }
        }
    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.interacted = true;
        return true;
    }

    async init() {
        console.log(...Log.w(`${this.constructor.name}`, 'LOG', 'Initialising...'));

        // REQUIRES A PARENT.
        if (!this.displayApp) throw new Error('App has no display App.');

        // Parent requires a bunch of functions
        this.validateDisplayAppImplementation();

        // This hook will run the custom function defined in the override itself.
        this.overrideHook();

        // Before rendering, do these things.
        this.preRenderHook();

        // Insert CSS into virtual element
        this.insertCSS(this.styles);

        // Insert HTML into virtual element
        this.insertHTML(this.markup);

        // Update HTML with Languages into the virtual element
        this.insertLanguages(this.language);

        // Run the pre mounted hook.
        this.beforeMountHook();

        // Once the mount point is available, create copies
        // and mount it. (This app might have a parent, so we let the parent
        // deal with the apps )
        if (!this.parent) {
            await this.mountElements();

            // Now mounted, run the post hooks
            this.postRenderHook();
        }

        console.log(...Log.w(`${this.constructor.name}`, 'LOG', 'Initialised'));
    }

    async uploadPicture(file) {
        console.log(...Log.w(`${this.constructor.name}`, 'LOG', 'Attempting Upload!'));

        this.displayApp.toggleLoading();

        // Response
        // send to render recommendations and update the main product.
        const myHeaders = {
            'api-key': this.productPageInfo.retailerConfig.apiKey,
        };
        const payload = new FormData();
        payload.append('image', file);
        payload.append('accountId', this.productPageInfo.retailerId);
        payload.append('cache', this.productPageInfo.retailerConfig.useCache);

        // Now add in the filters if any exist
        // for (const filter in this.apiFilter) {
        //     if (this.apiFilter.hasOwnProperty(filter)) {
        //         payload.append(filter, this.apiFilter[filter]);
        //     }
        // }

        // gender filters of course.
        if (this.apiFilter?.genderFiltering && this.displayApp?.product?.gender) {
            const productGender = this.displayApp.product.gender;
            payload.append('filterGender', productGender);
        }

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: payload,
            redirect: 'follow',
        };

        try {
            const response = await fetch(this.productPageInfo.retailerConfig.urls.apis.image_uploader_api, requestOptions);
            const result = await response.json();
            const imageURL = { title: 'Your Image' };
            imageURL.url = URL.createObjectURL(file);
            this.displayApp.uploadResponseAnalytics();
            const newFeed = result.response.response_object.new_feed;

            if (newFeed.length === 0) {
                console.log(...Log.w(`${this.constructor.name}`, 'WARN', 'No Recommendations found'));
                this.displayApp.toggleLoading();
                this.displayApp.errorPage(
                    this.language.upload_button_app.modal.title,
                    'No recommendations found for this image. Please try again with a different image.',
                );
            } else {
                this.displayApp.renderUploadRecommendations(newFeed, file);
            }

            // ! DECOUPLE
            if (this.goBack) this.flipButtons();

            return newFeed;
        } catch (error) {
            console.log(...Log.w(`${this.constructor.name}`, 'ERROR', `Upload Failed ${error}`));
            this.displayApp.toggleLoading();
            this.displayApp.errorPage(
                this.language.upload_button_app.modal.title,
                this.language.upload_button_app.modal.description,
            );
        }
    }

    flipButtons() {
        if (this.displayApp.cropperRestart) {
            this.displayApp.cropperRestart();
        }

        // Toggle the displayed content
        this.runFunctionOnAllCopies((elm) => {
            // Remove all event listeners
            // const clonedElement = elm.cloneNode(true);
            // elm.parentNode.replaceChild(clonedElement, elm);

            const texts = [
                ...elm.querySelectorAll('[titleBack]'),
                ...elm.querySelectorAll('[title]')];

            const icons = [
                ...elm.querySelectorAll('[cameraIcon]'),
                ...elm.querySelectorAll('[backArrowIcon]')];

            for (const text of texts) {
                if (text.style.display === 'none') {
                    text.style.display = 'unset';
                } else {
                    text.style.display = 'none';
                }
            }

            for (const icon of icons) {
                if (icon.style.display === 'none') {
                    icon.style.display = 'unset';
                } else {
                    icon.style.display = 'none';
                }
            }

            // Determine what state the button is currently in.
            // The continue / upload mode.

            // If the state is in upload mode, apply the upload
            // event listeners (we disable the input via prevent default)

            // If the state is in continue mode, we apply the click
            // event so that it will revert the UIs / parents state.
            const continueButton = elm.querySelector('[backArrowIcon]');
            if (continueButton && continueButton.style.display === 'unset') {
                elm.addEventListener('click', this.continueButtonHandler, { once: true });
            }
        });
    }

    continueButton(event) {
        // Prevent the default behavior of the event.
        event.preventDefault();
        this.displayApp.restoreOldDefaultView();
        // this.elementCopies.forEach((elm) => {
        //     const x = elm.shadowRoot;
        //     x.removeEventListener('click', this.continueButtonHandler);
        // });
        this.flipButtons();
    }

    restoreFeed() {

    }

    async mountElements(selectionRoot = document) {
        // God this was hard to make,
        // but now it will parallelize all the mounting.
        // as opposed to waiting for each one, do all at once.
        let counter = 0;

        const insertPromises = [];

        for (const point of this.mountPoints) {
            try {
            // Deconstruct mountPoint Details
                const mountPoints = point.mount_points;

                // Create a function to insert elements for a single mount point
                // eslint-disable-next-line no-loop-func
                const insertElementsForMountPoint = async (mountPoint) => {
                    try {
                        await this.waitForElementToExist(mountPoint, selectionRoot);

                        // Insert into DOM based upon the mount-point.
                        const newElements = this.mountMultipleElementsToPoints(mountPoint, selectionRoot);

                        // Insert attributes into the new elements
                        newElements.forEach((elm) => {
                            const root = elm.shadowRoot.querySelector('section');
                            root.setAttribute('mountId', point.mount_id);
                            root.setAttribute('language', this.productPageInfo.languageCode);
                            point.attributes.forEach((attr) => {
                                root.setAttribute(attr, '');
                            });
                        });

                        this.root.setAttribute('language', this.productPageInfo.languageCode);
                        this.root.setAttribute('mountPointIndex', counter);

                        // Any other logic required for this app.
                        // In this case, mount event listeners.
                        this.createEventListeners(newElements);

                        // Does it require any special logic for the CTA?
                        // this.postElementMount(newElements);

                        counter += 1;
                    } catch (error) {
                        console.warn(error);
                        console.log(...Log.w(`${this.constructor.name}`, 'WARN', `Could not mount this element correctly ${error}`));
                        return true;
                    }
                    return true;
                };

                // Create an array of promises for insertElementsForMountPoint
                const insertPromisesForPoint = mountPoints.map((mountPoint) => insertElementsForMountPoint(mountPoint));

                // Add these promises to the main insertPromises array
                insertPromises.push(...insertPromisesForPoint);
            } catch (error) {
                console.error(`Could not mount these elements correctly  ${error}`);
                console.log(...Log.w(`${this.constructor.name}`, 'ERROR', `Could not mount these elements correctly ${error}`));
            }
        }

        // Use Promise.all to insert elements for all mount points concurrently
        await Promise.all(insertPromises);

        console.log(...Log.w(`${this.constructor.name}`, 'LOG', `Mounted ${counter} elements`));
        return true;
    }

    setFile(element, file) {
        const input = this.element.shadowRoot.querySelector('[pictureInput]');
    }

    createEventListeners(elements) {
        for (const element of elements) {
            // For when the inputs change. Upload the picture
            const input = element.shadowRoot.querySelector('[pictureInput]');
            input.addEventListener('change', async (e) => {
                await this.uploadPicture(e.target.files[0]);
                input.value = null;
            });
        }
    }

    updateLanguagesForAllCopies(langs) {
        // !! Update for 0.6 to instead use the WW function, runFunctionOnAllCopies
        this.elementCopies.forEach((elm) => {
            this.recursiveLanguageInsertion(langs, '', elm);
        });
    }

    insertLanguages(langs) {
        this.recursiveLanguageInsertion(langs, '');
        return true;
    }
}
